module.exports = __webpack_public_path__ + "static/media/icon-wetdoorunlocked.606dcacc.svg";